import {
  Component,
  OnInit,
  DestroyRef,
  inject,
  ViewChild,
  ElementRef,
  computed,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlaylistService } from '../../services/playlist.service';
import { YoutubeThumbnailComponent } from '../youtube-thumbnail/youtube-thumbnail.component';
import { SocketService } from '../../services/socket.service';
import { ToasterService } from '../toaster/toaster.service';

// TODO: Tee nupp mis viib su praegusele positsioonile, kui oled välja scrollinud mujale
// TODO: Väike punane jooneke, mis näitab kuhu praeguse video positsioon on NB!!!

@Component({
  standalone: true,
  imports: [YoutubeThumbnailComponent],
  selector: 'playlist',
  templateUrl: './playlist.component.html',
  styleUrl: './playlist.component.scss',
})
export class PlaylistComponent implements OnInit {
  @ViewChild('playlistContainer') playlistContainer!: ElementRef<HTMLElement>;

  private playlistService = inject(PlaylistService);
  private socketService = inject(SocketService);
  private toaster = inject(ToasterService);
  private destroyRef = inject(DestroyRef);

  videos = this.playlistService.playlistVideos;
  playlistName = this.playlistService.playlistName;

  nowPlaying = computed(() => {
    const nowPlaying = this.playlistService.nowPlaying();
    if (nowPlaying.position) {
      setTimeout(() => {
        this.scrollToPosition(nowPlaying.position);
      }, 500);
    }
    return nowPlaying;
  });

  ngOnInit() {
    this.socketService.connect();
    this.socketService.onVideoAdded();
    this.socketService.onNowPlaying();

    this.playlistService.loadPlaylist();
    this.playlistService
      .getNowPlaying()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: nowPlaying => {
          this.playlistService.nowPlaying.set(nowPlaying);
        },
        error: err => {
          console.error('❌ Failed to load now playing:', err);
        },
      });

    this.socketService.videoAdded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(video => {
        this.playlistService.loadPlaylist();
        this.playlistService.loadNext();
        this.toaster.newVideoAdded(video);
        console.log('📼 New video added:', video);
      });

    this.socketService.nowPlaying$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(video => {
        console.log('▶️ Now playing:', video);
        this.playlistService.nowPlaying.set(video);
        this.playlistService.loadPlaylist();
        this.playlistService.loadNext();
        setTimeout(() => {
          this.scrollToPosition(video.position);
        }, 500);
      });

  }

  // TODO: scrollTo peaks olema alati ekraani ülevalt servast ~100px allpool
  scrollToPosition(pos: number) {
    const container = this.playlistContainer?.nativeElement;
    if (container) {
      const target = container.querySelector(
        `[data-position="${pos}"]`
      ) as HTMLElement;
      if (target) {
        const containerHeight = container.clientHeight;
        const targetHeight = target.offsetHeight;
        const targetOffset = target.offsetTop;

        // Calculate the scroll position to center the target
        let scroll = targetOffset - containerHeight / 2 + targetHeight / 2;

        // Clamp scroll value to container scroll range
        scroll = Math.max(
          0,
          Math.min(scroll, container.scrollHeight - containerHeight)
        );

        // Only scroll if not already centered (optional)
        if (
          container.scrollTop !== scroll &&
          (scroll > 0 || container.scrollTop !== 0)
        ) {
          container.scrollTo({ top: scroll, behavior: 'smooth' });
        }
      }
    }
  }
}
